export default "__VITE_ASSET__23178f2d__"